// extracted by mini-css-extract-plugin
module.exports = {"root":"SortAdornment_root__p44cD","icon":"SortAdornment_icon__3OusI","up":"SortAdornment_up__2HQCV","down":"SortAdornment_down__9K5DT","active":"SortAdornment_active__3VFLO"};